const API_BASE = "https://ceymoslanka.com/backend/api";

export default API_BASE;
